import React from 'react';

const LinkIcon = (props: any) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.9853 9.30841L12.4465 7.84714C13.607 6.65741 13.5951 4.75578 12.4199 3.58061C11.2448 2.40544 9.34314 2.39359 8.15341 3.55402L6.69214 5.01529"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9.7788 6.22168L6.22131 9.77916" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M5.01481 6.69238L3.55353 8.15366C2.3931 9.34338 2.40495 11.245 3.58012 12.4202C4.75529 13.5954 6.65693 13.6072 7.84665 12.4468L9.30793 10.9855"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LinkIcon;
